var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.92 3.394a1 1 0 0 0-1.578-1.147l-8 7A1 1 0 0 0 5.002 11h3.484l-2.403 5.607a1 1 0 0 0 1.578 1.146l8-7a1 1 0 0 0 .278-1.103A1 1 0 0 0 15 9.003h-3.484z"
  })));
};
export default SvgBolt;